import { Box, Button, IconButton, Modal, TextField } from "@mui/material";

import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";

import { isValidInput } from "../utils/validations";
import { isString } from "formik";

type props = {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  revert: string;
  setRevert: Dispatch<SetStateAction<string>>;
  handleSubmit: () => void;
  error: boolean;
  setError: Dispatch<SetStateAction<boolean>>;
};
export const RevertModal = ({
  openModal,
  setOpenModal,
  revert,
  setRevert,
  error,
  setError,
  handleSubmit,
}: props) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#ffff",
    boxShadow: 24,
    p: 6,
    borderRadius: 3,
    outline: "none",
  };
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="logout_mdl"
    >
      <Box sx={style}>
        <IconButton
          onClick={() => {
            setOpenModal(false);
            setRevert("");
            setError(false);
          }}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#252525",
          }}
        >
          <CloseIcon />
        </IconButton>

        <div className="control_group w_100">
          <label>Revert</label>

          <TextField
            variant="outlined"
            placeholder="Revert"
            fullWidth
            hiddenLabel
            value={revert}
            onChange={(val) => {
              if (
                isValidInput(val.target.value) &&
                isString(val.target.value)
              ) {
                setRevert(val.target.value);
              }
            }}
            inputProps={{ maxLength: 200 }}
            multiline
            minRows={3}
            maxRows={4}
          />
          {error && !revert?.length ? (
            <h6 className="err_msg">This field is required</h6>
          ) : error && revert?.length <= 2 ? (
            <h6 className="err_msg">
              Revert must be atleast 3 characters long
            </h6>
          ) : null}
        </div>

        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "center",
            paddingTop: "20px",
          }}
        >
          <Button
            className="btn btn_blue"
            sx={{ minWidth: "100px" }}
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </Button>

          <Button
            className="btn btn_blue"
            sx={{ minWidth: "100px" }}
            onClick={() => {
              setOpenModal(false);
              setRevert("");
              setError(false);
            }}
          >
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
